module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"share":"Teilen","close":"Schließen","copyToClipboard":"In die Zwischenablage kopieren"},"en":{"share":"Share","close":"Close","copyToClipboard":"Copy to clipboard"}}')
  delete Component.options._Ctor
}
